<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true}">
        <h4>{{d.name}}</h4>
        <div class="categoryCnt">
          <div class="fieldGroup variantItem" v-for="(item, i) in d.items" :key="i"
            :class="{hasColor: d.id === 1}"
            v-on:click="close(true, item)">
            <div class="variantColor" :style="{'background-color': item.color}"
              v-on:click="setColor(i, item)" v-if="d.id === 1"></div>
            <h4>{{item.name}}</h4>
          </div>
        </div>
      </div>
      <ColorPicker ref="colorPicker"/>
    </div>
  </transition>
</template>

<script>
import ColorPicker from '@/components/ColorPicker.vue';

export default {
  name: 'variantEditor',
  components: { ColorPicker },
  data() {
    return {
      show: false,
      next: null,
      d: null,
      loading: false,
    };
  },
  methods: {
    open(d, next) {
      this.d = d;
      this.show = true;
      this.next = next;
      this.loading = false;
      document.getElementsByTagName('BODY')[0].classList.add('stopscroll');
    },
    close(b, v) {
      this.show = false;
      document.getElementsByTagName('BODY')[0].classList.remove('stopscroll');
      if (this.next && typeof this.next === 'function') this.next(b, v);
    },
    setColor(i, item) {
      this.$refs.colorPicker.open(item, (b, color) => {
        if (!b) return;
        this.variantItems[i].color = color;
      });
    },
    saveNow() {
      if (this.loading) return;
      const formData = {
        name: this.form.name.model,
        items: this.variantItems,
      };
      if (!formData.name || formData.name === '') {
        this.form.name.error = true;
        return;
      }
      if (this.d) formData.id = this.d.id;
      this.loading = true;
      this.$http.post(this.$config.uri('product/variant/save'), formData).then((r) => {
        this.loading = false;
        this.close(true);
      });
    },
    deleteVariant(i, item) {
      this.variantItems.splice(i, 1);
    },
    addVariantItem() {
      this.variantItems.push({ model: '', color: '#EEEEEE', id: 0 });
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 60px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      width: 340px;
      &.hasCheck{
        text-align: left;
      }
      h4{
        margin: -30px -60px 0;
        padding: 14px 60px 10px;
        border-bottom: #eee 1px solid;
        font-size: 24px;
        font-weight: normal;
        color: #444;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .addVariantCnt{}
      .addVariant{
        white-space: nowrap;
        width: auto;
        color: #0e5dd2;
        opacity: 1;
        display: inline-block;
        cursor: pointer;
        border: #0e5dd2 1px solid;
        border-radius: 50px;
        line-height: 30px;
        height: 30px;
        padding: 0 10px;
        position: relative;
        padding-left: 34px;
        margin-bottom: 20px;
        &:hover{
          background-color: #f5f5f5;
          box-shadow: 0 0 4px rgba(0,0,0,.2);
        }
        &:before{
          top: 0; left: 6px; bottom: 0;
          content: "";
          position: absolute;
          width: 20px;
          background-image: url(../assets/plus-circle.png);
          background-size: 20px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .categoryCnt{
        padding: 10px 60px;
        margin: 0 -60px;
        min-height: 140px;
        max-height: 400px;
        overflow-y: auto;
        h4{
          margin: 0 0 10px;
          font-size: 20px;
          padding: 0;
          border: none;
        }
        .fieldGroup{
          &.variantItem{
            position: relative;
            margin-bottom: 8px;
            min-height: 40px;
            display: flex;
            padding-left: 16px;
            cursor: pointer;
            &.hasColor{
              padding-left: 48px;
            }
            &:hover{
              background-color: #f5f5fe;
              border-radius: 5px;
            }
            h4{
              margin: 0;
              line-height: 39px;
            }
            .variantColor{
              position: absolute;
              left: 5px; top: 5px;
              width: 28px; height: 28px;
              background-color: #eee;
              border-radius: 3px;
              border: #eee 1px solid;
              cursor: pointer;
              transition: all .3s ease;
              &:hover{
                box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
              }
            }
          }
        }
      }
    }
  }
</style>
